import { h, render } from 'preact';

import ViewportSwitch from './components/ViewportSwitch';
import Desktop from './scenes/Desktop';
import Mobile from './scenes/Mobile';


const abilitiesData = [{
    key: `${window.i18n.abilities.passive.titleShort}`,
    keyLong: 'PASSIVE',
    title: `${window.i18n.abilities.passive.titleCombined}`,
    subtitle: `${window.i18n.abilities.passive.subtitle}`,
    description: [
        `${window.i18n.abilities.passive.ionianFervor}`,
    ],
    youtubeId: `${window.i18n.abilities.passive.youtubeid}`,
    thumbnail: '/img/content/abilities/icon-p.jpg',
},
{
    key: false,
},
{
    key: `${window.i18n.abilities.q.titleShort}`,
    title: `${window.i18n.abilities.q.titleCombined}`,
    subtitle: `${window.i18n.abilities.q.subtitle}`,
    description: [
        `${window.i18n.abilities.q.copy}`,
        `${window.i18n.abilities.q.copyTwo}`,
    ],
    youtubeId: `${window.i18n.abilities.q.youtubeid}`,
    thumbnail: '/img/content/abilities/icon-q.jpg',
},
{
    key: `${window.i18n.abilities.w.titleShort}`,
    title:  `${window.i18n.abilities.w.titleCombined}`,
    subtitle: `${window.i18n.abilities.w.subtitle}`,
    description: [
        `${window.i18n.abilities.w.firstCast}`,
        `${window.i18n.abilities.w.secondCast}`,
    ],
    youtubeId: `${window.i18n.abilities.w.youtubeid}`,
    thumbnail: '/img/content/abilities/icon-w.jpg',
},
{
    key: `${window.i18n.abilities.e.titleShort}`,
    title:  `${window.i18n.abilities.e.titleCombined}`,
    subtitle: `${window.i18n.abilities.e.subtitle}`,
    description: [
        `${window.i18n.abilities.e.copy}`,
    ],
    youtubeId: `${window.i18n.abilities.e.youtubeid}`,
    thumbnail: '/img/content/abilities/icon-e.jpg',
},
{
    key: `${window.i18n.abilities.r.titleShort}`,
    title:  `${window.i18n.abilities.r.titleCombined}`,
    subtitle: `${window.i18n.abilities.r.subtitle}`,
    description: [
        `${window.i18n.abilities.r.copy}`,
    ],
    youtubeId: `${window.i18n.abilities.r.youtubeid}`,
    thumbnail: '/img/content/abilities/icon-r.jpg',
}];

render((
    <ViewportSwitch
        queryString="(min-width: 768px)"
        PassComponent={<Desktop data={abilitiesData} />}
        FailComponent={<Mobile data={abilitiesData} />}
    />
), document.querySelector('#abilities-app'));



// WEBPACK FOOTER //
// ./src/js/AbilitiesPlayer/index.js